import React from 'react'
import { Navigate } from 'react-router-dom'

const RoleProtectedRoute = ({allowRoles,children}) => {
    const role = localStorage.getItem('userRole')
  
    if(!allowRoles.includes(role)) {
        return <Navigate to="/not-authorized" replace />

    }
    return children
}

export default RoleProtectedRoute